module.exports = __webpack_public_path__ + "static/media/other-income-other.2bcac245.svg";